import "./GroupSection.module.css";
import Header from "@/reusable_sections/Header";
import HarmonicScience from "./sections/HarmonicScience";
import CatalogoServizi from "./sections/CatalogoServizi";
import InfoFooter from "@/reusable_sections/Footer";
export default function GroupSectionPage() {
  return <div>
      <Header />
      <HarmonicScience />
      <CatalogoServizi />
      <InfoFooter />
    </div>;
}